export default {"src":"/_next/static/media/friend_icon.cbc9c0bb.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};